module.exports = __webpack_public_path__ + "img/block_5.4d70b94e.webp";